import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'r2b_referrals-clicks_on_sign_up_to_sell_button-click';

/**
 * Tracks the clicks on the sign up to sell button on the landing page for brands with bonus offers
 */
export function trackR2BReferralsClicksOnSignUpToSellButtonClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
